module.exports = __webpack_public_path__ + "static/media/icon-rank-mini-3.2a75f33b.png";